import React from 'react';
import Hero from '../components/contactUs/Hero';
import { Helmet } from 'react-helmet';

const GetInvolvedPage = () => {
    
    return (
        <div className="min-h-screen bg-white">
            <Helmet>
                <title>Contact Frost & Grey | AI Consulting & Training Inquiries</title>

                <meta
                    name="description"
                    content="Get in touch with Frost & Grey for AI training, enterprise AI consulting, partnerships, and media inquiries. Our team responds within 72 hours."
                />

                <link rel="canonical" href="https://frostandgrey.com/contact-us" />

                <meta property="og:title" content="Contact Frost & Grey" />
                <meta property="og:description" content="Reach out for AI consulting, enterprise training, or strategic partnerships." />
                <meta property="og:url" content="https://frostandgrey.com/contact-us" />
                <meta property="og:type" content="website" />
            </Helmet>

            <Hero />
        </div>
    );
};

export default GetInvolvedPage;